<template>
    <div class="intercept-detail">
        <div class="intercept-no" style="margin: 15px 0; margin-bottom: 20px">
            <span class="margin-right-5"
                >{{
                    $t("erp.b2c.intercept_tracking_number", {
                        defaultValue: "拦截单号",
                    })
                }}:</span
            >
            <span class="margin-right-10 font-weight">{{
                formData.interceptNo || "--"
            }}</span>
            <span :class="`border-container color-${status.theme}`">{{
                status.label || "--"
            }}</span>
        </div>
        <div class="intercept-containter">
            <compWrapper
                :title="
                    $t('erp.b2c.intercept_information', {
                        defaultValue: '拦截信息',
                    })
                "
                theme="primary"
            >
                <Table
                    class="margin-15"
                    :data="dataList"
                    :columns="columns"
                    size="small"
                    border
                ></Table>
            </compWrapper>
            <compWrapper
                :title="
                    $t('global.common.operation_history', {
                        defaultValue: '操作历史',
                    })
                "
                theme="gray"
            >
                <compLog :data="logList" :columns="logColumn"></compLog>
            </compWrapper>
        </div>
        <Spin v-if="loading" fix></Spin>
    </div>
</template>

<script>
import mixin from "./mixin";
import { HttpGetInterceptDetail } from "@/service/intercept/index";
export default {
    mixins: [mixin],
    props: ["activeid", "querytype"],
    data() {
        return {
            status: {},
            formData: {},
            dataList: [],
            logList: [],
            loading: false,
        };
    },
    created() {
        this.getDetail();
    },
    computed: {
        columns() {
            return [
                {
                    title: this.$t("erp.b2c.shipping_order_number", {
                        defaultValue: "发货单号",
                    }),
                    key: "deliverOrderNo",
                },
                {
                    title: this.$t("erp.b2c.shipment_status", {
                        defaultValue: "发货单状态",
                    }),
                    key: "deliverStatus",
                    render: (h, { row }) => {
                        let item = this.getDeliveryStatus.filter((item) => {
                            return item.value == row.deliverStatus;
                        })[0];
                        return <div>{item.label}</div>;
                    },
                },
                {
                    title: this.$t("erp.b2c.intercept_status", {
                        defaultValue: "拦截状态",
                    }),
                    key: "status",
                    render: (h, { row }) => {
                        let label = this.getInterceptStatus.filter((item) => {
                            return item.value == row.status;
                        })[0];
                        let isBilling = row.isBilling == 1;
                        let isBillingEle = (
                            <span style="margin-left: 10px; color: #fff; background: #ed4014; padding: 5px 10px;">
                                {$t("erp.b2c.charging", {
                                    defaultValue: "计费",
                                })}
                            </span>
                        );
                        return (
                            <div>
                                {label.label}
                                {isBilling ? isBillingEle : ""}
                            </div>
                        );
                    },
                },
            ];
        },
        logColumn() {
            return [
                {
                    title: this.$t("global.log.operator", {
                        defaultValue: "操作人",
                    }),
                    key: "createdName",
                },
                {
                    title: this.$t("global.common.operate_time", {
                        defaultValue: "操作时间",
                    }),
                    key: "createdAt",
                },
                {
                    title: this.$t("global.common.notes", {
                        defaultValue: "备注",
                    }),
                    key: "message",
                },
            ];
        },
    },
    methods: {
        async getDetail() {
            this.loading = true;
            await HttpGetInterceptDetail({
                id: this.activeid,
            }).then(
                (res) => {
                    this.formData = res.data;
                    this.dataList = res.data.interceptInfoEntityList;
                    this.logList = res.data.interceptOrderLogEntityList;
                    this.status = this.getInterceptStatus.filter((item) => {
                        return item.value == res.data.interceptStatus;
                    })[0];
                },
                (err) => {
                    this.$VMessage.error(err.message);
                }
            );
            this.loading = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.intercept-detail {
    .border-container {
        border: 1px solid #ccc;
        border-radius: 5px;
        padding: 3px 10px;
    }
    .color-primary {
        border-color: #2d8cf0;
    }
    .color-warning {
        border-color: #ff9900;
    }
    .color-success {
        border-color: #19be6b;
    }
    .color-error {
        border-color: #ed4014;
    }
}
</style>
